var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoritechecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1850"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1851"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 59",
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#FF3939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.2894 12.8009C17.5878 12.5169 17.8531 12.2167 18.1653 11.9739C20.2337 10.3618 23.0706 10.7946 24.6442 12.9497C26.0369 14.8574 25.9387 17.3897 24.399 19.2248C23.5526 20.2338 22.5794 21.1209 21.5548 21.9498C20.3705 22.9095 19.155 23.8333 17.9477 24.7661C17.5575 25.0681 17.0994 25.077 16.7175 24.7966C14.8979 23.4614 13.1048 22.0931 11.4808 20.5313C10.9217 19.9937 10.3754 19.4273 9.9182 18.8082C8.24271 16.5375 8.94045 13.1513 11.3587 11.6531C13.2416 10.4873 15.7755 10.9389 17.2031 12.6961C17.2353 12.7364 17.2683 12.7758 17.2894 12.8009ZM17.3152 14.0716C17.2812 14.0321 17.261 14.0115 17.2435 13.9891C16.9626 13.6334 16.7065 13.2543 16.3971 12.9246C15.1779 11.6271 13.1535 11.3654 11.7259 12.3C9.6235 13.6755 9.11305 16.559 10.6389 18.5313C10.9648 18.9524 11.332 19.3476 11.714 19.7212C13.3858 21.3584 15.2412 22.7858 17.126 24.1774C17.2702 24.284 17.3877 24.2607 17.518 24.1595C18.5904 23.3261 19.6764 22.5107 20.7332 21.6585C21.799 20.7992 22.8227 19.8915 23.7243 18.861C24.6763 17.7723 25.0518 16.5214 24.7791 15.1137C24.5349 13.8538 23.8574 12.8502 22.7144 12.2033C21.1261 11.3036 19.0907 11.7561 17.9642 13.2176C17.7512 13.4945 17.541 13.7741 17.3161 14.0698L17.3152 14.0716Z",
    fill: "white",
    stroke: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritechecked);
export default __webpack_public_path__ + "static/media/favoritechecked.e62a255c27699447d72b80c3b5d99472.svg";
export { ForwardRef as ReactComponent };